import { Typography, Skeleton as UiSkeleton, styled } from "@l2r-front/l2r-ui"

export const Title = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(5),
}))

export const Container = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const ContentContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
}))

export const TrafficStatContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
}))

export const Skeleton = styled(UiSkeleton)({
    height: 103,
    transform: "scale(1)",
    width: "100%",
})

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
}))